import { render, staticRenderFns } from "./SummaryContact.vue?vue&type=template&id=79a64343&scoped=true&"
import script from "./SummaryContact.vue?vue&type=script&lang=js&"
export * from "./SummaryContact.vue?vue&type=script&lang=js&"
import style0 from "./SummaryContact.vue?vue&type=style&index=0&id=79a64343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a64343",
  null
  
)

export default component.exports